import React from 'react';
import { connect } from 'react-redux';
import CustomScrollTrigger from 'js/wrapper/CustomScrollTrigger';
import { Parallax } from 'react-scroll-parallax';

import { submitLogin } from 'actions/LoginActions';

import LoginForm from 'components/forms/auth/LoginForm';
import LoginSocialMediaButtons from 'components/layout/LoginSocialMediaButtons';

import RichEditorContent from 'components/RichEditorContent';
import AbstractCmsElement from './AbstractCmsElementNew';


class CmsElementLoginForm extends AbstractCmsElement {
  constructor(props) {
    super(props);

    this.allowStateChange = true;

    this.state = {
      shown: false,
      isOAuthRedirecting: false,
    };
  }

  handleOAuthRedirect = (isRedirecting) => {
    this.setState({ isOAuthRedirecting: isRedirecting });
  };

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  };

  onSubmit = args => {
    this.props.onSubmit(args, this.props.appIntl.urlPrefix);
  };

  componentWillUnmount = () => {
    clearTimeout(this.submitTimeout);
    this.__componentWillUnmount();
  };

  render() {
    const {
      intl: { messages },
      projectConfig,
      hideTitle,
      socialMediaLoginState,
    } = this.props;
    const { shown } = this.state;

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
    const textClass = 'text-' + this.getParamValue('mainColor', 'master') + ' ';
    const { whiteLabelSettings } = globalThis;

    const alzuraEnabled =
      whiteLabelSettings.alzura_oauth_enabled || whiteLabelSettings.alzuraOAuthEnabled;

    const showSocialMediaLogin =
      projectConfig.data?.facebook_login_client_id ||
      projectConfig.data?.google_login_client_id ||
      projectConfig.data?.microsoft_login_client_id ||
      alzuraEnabled;

    const parallaxData = this.getParallaxData();

    const { isOAuthRedirecting } = this.state;

    const innerContent = (
      <div
        id={this.getMainId()}
        className={'ms-login-form-content ' + shownClass + this.getCssClasses()}
        style={{ ...this.getBackgroundStyle(), position: 'relative' }}
      >
        {this.getElementStyle()}

        {/* Overlay when redirecting to OAuth */}
        {isOAuthRedirecting && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(255, 255, 255, 0.8)',
              zIndex: 1000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 'inherit',
            }}
          >
            <div style={{ textAlign: 'center' }}>
              <i className="fa fa-spinner fa-spin" style={{ fontSize: '48px', color: '#667eea', marginBottom: '10px' }} />
              <p style={{ color: '#333', fontSize: '16px', fontWeight: 500 }}>{messages.redirecting_to_alzura}</p>
            </div>
          </div>
        )}

        <div className="ms-login-form-container" style={{ pointerEvents: isOAuthRedirecting ? 'none' : 'auto', opacity: isOAuthRedirecting ? 0.6 : 1 }}>
          {!hideTitle && (
            <h4 className={'no-margin p-b-5 ' + textClass}>
              <i className="fa fa-lock m-r-5" /> {this.getParamValue('title', '')}
            </h4>
          )}

          <RichEditorContent content={'<p className="' + textClass + '">' + this.getParamValue('content', '') + '</p>'} />

          <LoginForm onSubmit={this.onSubmit} buttonTitle={this.getParamValue('buttonTitle', messages.button_signin)} />

          {showSocialMediaLogin && (
            <div className="m-t-30">
              <h4>
                <center>{messages.alternative_login_long}</center>
              </h4>

              <center>
                <LoginSocialMediaButtons
                  socialMediaLoginState={socialMediaLoginState}
                  onOAuthRedirect={this.handleOAuthRedirect}
                />
              </center>
            </div>
          )}
        </div>

        {this.getAppendHtml()}
      </div>
    );

    return (
      <CustomScrollTrigger className="cms-overflow-fix" onEnter={this.shown} {...this.getCustomId()}>
        {parallaxData ? (
          <Parallax {...parallaxData}>
            {innerContent}
          </Parallax>
        ) : (
          innerContent
        )}
      </CustomScrollTrigger>

    );
  }
}
CmsElementLoginForm.defaultProps = {
  index: '0',
  socialMediaLoginState: null,
  hideTitle: false,
};

const mapStateToProps = state => {
  return {
    projectConfig: state.data.projectConfig,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  const res = {};

  if (!ownProps.onSubmit) {
    res.onSubmit = (args, urlPrefix) => {
      dispatch(submitLogin(args, urlPrefix));
    };
  }

  return res;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CmsElementLoginForm);
